import {getStreamDay, parseBool} from "./tools";
import BBCode from "../../../web/lib/bbcode-parser/parser";
import {episodeLikeToggle} from "./api";
import storage from "./storage";
import "jquery.cookie";
import moment from "moment";
import { replaceUrlsToLinks } from "../../platform/src/helpers/html-helpers";
import {getStreamDayRange, getStreamDayRangeBySessions} from "../../common/src";

const MEDIA_SERVER_TYPE_WOWZA = 'wowza';
const MEDIA_SERVER_TYPE_FLUSSONIC = 'flussonic';

function Entity() {}
Entity.localeName = ko.observable('ru');
Entity.localePropertyName = (name) => {
	return name
		+ Entity.localeName().substr(0, 1).toUpperCase()
		+ Entity.localeName().substr(1, 1).toLowerCase()
	;
};
Entity.prototype.fillFrom = function(data) {
	Object.keys(this.__mapper).forEach((name) => {
		const options = this.__mapper[name];
		const sourceKey = (options.keys || []).concat([name]).find(key => undefined !== data[key]) || name;
		let value = data[ sourceKey ];

		if(!this[name]) {
			this[name] = ko.observable();
		}

		if(undefined === value) {
			if(undefined === this[name]()) {
				value = options['default'];
			}
			if(undefined === value) return;
		}

		if(typeof value === 'function') {
			value = value();
		}

		if(options.type instanceof Array) {
			if(options.type.indexOf(value) < 0 && typeof options['default'] !== 'undefined') {
				value = options['default'];
			}
		}

		switch(options.type) {
			case 'bool': value = parseBool(value); break;
			case 'int':
				value = parseInt(value);
				value = isNaN(value) ? null : value;
				break;
			case 'float':
				value = parseFloat(value);
				value = isNaN(value) ? null : value;
				break;
			case 'timestamp': value = new Date(value * 1000); break;
		}

		this[name](value);
	});

	return this;
};
Entity.prototype.setMapper = function(mapper) {
	this.__mapper = mapper;

	return this;
};
Entity.prototype.getCleanData = function() {
	const data = {};

	for(let name in this.__mapper) {
		if(this.__mapper.hasOwnProperty(name)) {
			((name/*, options*/) => {
				if(typeof this[name] === 'undefined') return;
				data[name] = typeof this[name] === 'function' ? this[name]() : this[name];
			})(name, this.__mapper[name]);
		}
	}

	return data;
};
Entity.extend = function(dist) {
	dist.prototype = Object.create(Entity.prototype);
	dist.prototype.constructor = dist;
	dist.prototype._instance = {};
	dist.prototype.setInstance = function(id) {
		dist.prototype._instance[id] = this;
		return this;
	};
	dist.prototype.removeInstance = function() {
		const instance = dist.prototype._instance;
		for(let i in instance) {
			if(instance.hasOwnProperty(i)) {
				if(instance[i] === this) {
					delete instance[i];
				}
			}
		}
		return this;
	};
	dist.getInstance = function(id) {
		const instance = dist.prototype._instance;
		return instance[id] || null;
	};
};
Entity.timeNow = (() => {
	const timeNow = ko.observable(Math.round(Date.now() / 1000));
	setInterval(() => timeNow(Math.round(Date.now() / 1000)), 1000);
	return timeNow;
})();


Entity.AccessClient = function(data) {
	this.setMapper({
		id: { type: 'int' },
		name: { type: 'string' },
		alias: { type: 'string' },
        organizationName: { type: 'string' },
        organizationInn: { type: 'string' },
        settings: { type: 'object', 'default': {} }
	});
	this.fillFrom(data);
};
Entity.extend(Entity.AccessClient);

Entity.Client = function(data) {
//	this.setInstance(data.id);

	this.setMapper({
		id: { type: 'int' },
		type: { type: 'string' },
//		accountId: { type: 'int' },
		email: { type: 'string' },
//		surname: { type: 'string', 'default': '' },
//		name: { type: 'string', 'default': '' },
//		patronymic: { type: 'string', 'default': '' },
// 		avatar: { type: 'string' },
//		link: { type: 'string' },
		info: { type: 'object' }
	});
	this.fillFrom(data);

	this.nickname = ko.computed(() => {
		if (data.nickname) {
			return data.nickname;
		}

		const format = this.nicknameFormat() || '{surname} {name} {patronymic}';
		const info = this.info() || {};

		return info.nickname
			|| format.replace(/{([\w\d]+)}/gi, (m, name) => info[name] ? info[name] : '').trim()
			|| ('Зритель #' + this.id());
	});

	this.avatar = ko.computed(() => {
		if (data.avatar) {
			return data.avatar;
		}

		const info = this.info() || {};
		return info.avatar || '/player/images/avatar.svg';
	});
	this.link = ko.computed(() => {
		const info = this.info() || {};
		return info.link || null;
	});
};
Entity.extend(Entity.Client);
Entity.prototype.nicknameFormat = ko.observable('{surname} {name} {patronymic}');

Entity.Event = function(data) {
	this.setInstance(data.id);

	this.setMapper({
		id: { type: 'int' },
		name_ru: { type: 'string', keys: ['name', 'ru_name'] },
		name_en: { type: 'string', keys: ['en_name'] },
		timeStart: { type: 'int' },
		timeStop: { type: 'int' },
		eventKey: { type: 'string' },
		private: { type: 'bool', 'default': false },
		price: { type: 'float', 'default': null },
		participationType: { type: 'string' },
	});
	this.fillFrom(data);

	this.name = ko.computed(() => this['name_' + Entity.localeName()]() || this.name_ru());

	this.moduleMain = new Entity.Event.Module.Main(data.moduleMain, this);
	this.moduleActivity = new Entity.Event.Module.Activity(data.moduleActivity, this);
	this.moduleAuth = new Entity.Event.Module.Auth(data.moduleAuth, this);
	this.moduleBranding = new Entity.Event.Module.Branding(data.moduleBranding, this);
	this.moduleComment = new Entity.Event.Module.Comment(data.moduleComment, this);
	this.moduleQuestion = new Entity.Event.Module.Question(data.moduleQuestion, this);
	this.moduleTwitter = new Entity.Event.Module.Twitter(data.moduleTwitter, this);
	this.moduleInformation = new Entity.Event.Module.Information(data.moduleInformation, this);
	this.moduleEpisode = new Entity.Event.Module.Episode(data.moduleEpisode, this);
	this.moduleTheme = new Entity.Event.Module.Theme(data.moduleTheme, this);
	this.moduleSettings = new Entity.Event.ModuleSettings(data.moduleSettings || {});

	this.registrationFields = ko.observableArray(
		(data.registrationFields || [])
			.map(fieldToEvent => new Entity.Event.RegistrationField(Object.assign({}, fieldToEvent.field, {required: fieldToEvent.required})))
	);

	this.stream = ko.observableArray();
	this.banner = ko.observableArray();

	this.status = ko.computed(() => {
		if(!this.stream()) return 'idle';
		const idle  = this.stream().filter((stream) => stream.status() === 'idle').length > 0 ? 'idle' : null;
		const live  = this.stream().filter((stream) => stream.status() === 'live').length > 0 ? 'live' : null;
		const pause = this.stream().filter((stream) => stream.status() === 'pause').length > 0 ? 'pause' : null;
		const stop  = this.stream().filter((stream) => stream.status() === 'stop').length > 0 ? 'stop' : null;

		return live || pause || stop || idle || 'idle';
	});

	this.isArchived = ko.computed(() => !this.stream().find((s) => ['done', 'file'].indexOf(s.archiveStatus()) === -1));

	this.isIdle = ko.computed(() => this.stream().filter(stream => stream.status() !== 'idle').length === 0);
	this.isStopped = ko.computed(() => this.stream().filter(stream => stream.status() === 'stop').length === this.stream().length);

	this.manualStatusControl = ko.computed(() => this.stream().filter(stream => stream.manualStatusControl()).length > 0);

	this.episode = ko.computed(
        () => this.stream().reduce((episodes, stream) => episodes.concat(stream.episode()), [])
	);

	this.dayCount = ko.computed(() => Math.ceil((this.timeStop() - this.timeStart()) / (3600*24)));

	this.client = ko.observable(new Entity.AccessClient(data.client || {}));

	if (data.stream instanceof Array) {
		data.stream.forEach(stream => new Entity.Event.Stream(stream));
	}

	if (data.banner instanceof Array) {
		data.banner.forEach(banner => new Entity.Event.Banner(banner));
	}

	this.days = ko.computed(() => {
        const start = moment.unix(this.timeStart());
        const stop = moment.unix(this.timeStop());
        const countDays = stop.diff(start, 'days');
        const days = [];
        let day = 0;
        while (day <= countDays){
            days.push(moment.unix(this.timeStart()).add(day, 'days'));
            day++;
        }
        return days;
    });

	this.getPreview = ko.computed(() => this.stream()[0]?.getPreview() || null);

	this.timeStartMoment = ko.computed(() => {
		return moment.unix(this.timeStart());
	});
};
Entity.extend(Entity.Event);
Entity.Event.prototype.isEpisodeRecorded = function() {
	let recorded = this.episode().length > 0;
	this.episode().forEach((episode) => {
		if(episode.isDelay()) return;

		if(!in_array(episode.archiveStatus(), ['done', 'file'])) {
			recorded = false;
		}
	});

	return recorded;
};
Entity.Event.prototype.getStartStream = function() {
	let firstLiveStream = null,
		firstPauseStream = null,
		firstRecordStream = null;

	this.stream().forEach((stream) => {
		if(!firstLiveStream && in_array(stream.status(), ['live'])) {
			firstLiveStream = stream;
		} else if(!firstPauseStream && in_array(stream.status(), ['pause'])) {
			firstPauseStream = stream;
		} else if(!firstRecordStream && stream.dvr() && in_array(stream.status(), ['stop'])) {
			firstRecordStream = stream;
		}
	});

	return firstLiveStream || firstPauseStream || firstRecordStream;
};

Entity.Event.Module = function() {};

Entity.Event.Module.Main = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		autoplay: { type: 'bool', 'default': true },
		clientCertificateEnabled: { type: 'bool', 'default': false },
	});
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.Module.Main);

Entity.Event.Module.Activity = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		enabled: { type: 'bool' },
        position: { type: ['bottom', 'right', ''], 'default': 'bottom' },
		type: { type: 'string', 'default': 'event' },
		registrationPoints: { type: 'float', 'default': 0 },
		messagePoints: { type: 'float', 'default': 0 },
		messageReplyPoints: { type: 'float', 'default': 0 },
		questionPoints: { type: 'float', 'default': 0 },
		speakerQuestionPoints: { type: 'float', 'default': 0 },
		questionLikePoints: { type: 'float', 'default': 0 },
		pollAnswerPoints: { type: 'float', 'default': 0 },
        visibleCount: { type: 'int', 'default': 3 },
	});
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.Module.Activity);

Entity.Event.Module.Auth = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		rules: { type: 'bool' },
		customRulesRu: { type: 'string' },
		customRulesEn: { type: 'string' },
        customDescriptionRu: { type: 'string', 'default': '' },
        customDescriptionEn: { type: 'string', 'default': '' },
		rulesUrl: { type: 'string' },
		require: { type: 'bool' },
		participationFormatLabels: {type: 'array'},
		nickname: { type: 'string' },
		guest: { type: 'bool', 'default': false },
		guestNicknamePlaceholderRu: { type: 'string', 'default': '' },
		guestNicknamePlaceholderEn: { type: 'string', 'default': '' },
		vk: { type: 'bool' },
		facebook: { type: 'bool' },
		twitter: { type: 'bool' },
		mailru: { type: 'bool' },
		ok: { type: 'bool' },
		linkedin: { type: 'bool' },
		google: { type: 'bool' },
		yandex: { type: 'bool' },
		email: { type: 'bool' },
		requireEmail: { type: 'bool' },
		kaspersky: { type: 'bool' },
		allowedEmailDomain: {type: 'string', 'default': ''},
		accessByEmails: {type: 'bool'},
		accessPreModeration: {type: 'bool'},
        sso: {type: 'bool'},
        ssoIconUrl: {type: 'string', nullable: true},
		corporateMail: {type: 'bool', 'default': false},
		registrationType: { type: 'string', 'default' : 'hybrid'},
	});
	this.fillFrom(data);

	this.customRules = ko.computed(() => this[Entity.localePropertyName('customRules')]());

    this.customDescription = ko.computed(() => this[Entity.localePropertyName('customDescription')]());

	this.guestNicknamePlaceholder = ko.computed(() => this[Entity.localePropertyName('guestNicknamePlaceholder')]());

	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.Module.Auth);

Entity.Event.ModuleSettings = function(data) {
	data && data.id && this.setInstance(data.id);

	this.setMapper({
		eventId: { type: 'int' },
		backgroundImage: { type: 'string' },
		hideInfoBlock: { type: 'bool', 'default': false },
		posterImage: { type: 'string'},
		id: { type: 'int' },
		eventTitleRu: { type: 'string' },
		eventTitleEn: { type: 'string' },
		hideEventTitle: { type: 'bool', 'default': false },
		eventSubtitleRu: { type: 'string' },
		eventSubtitleEn: { type: 'string' },
		hideEventSubtitle: { type: 'bool', 'default': false },
		dateRu: { type: 'string' },
		dateEn: { type: 'string' },
		hideDate: { type: 'bool', 'default': false },
		hideFormat: { type: 'bool', 'default': false },
		enterOnly: { type: 'bool', 'default': false },
		loginSubtitleRu: { type: 'string' },
		loginSubtitleEn: { type: 'string' },
		hideLoginSubtitle: { type: 'bool', 'default': false },
		registrationSubtitleRu: { type: 'string' },
		registrationSubtitleEn: { type: 'string' },
		hideRegistrationSubtitle: { type: 'bool', 'default': false },
		successTitleRu: { type: 'string' },
		successTitleEn: { type: 'string' },
		hideSuccessTitle: { type: 'bool', 'default': false },
		successSubtitleRu: { type: 'string' },
		successSubtitleEn: { type: 'string' },
		hideSuccessSubtitle: { type: 'bool', 'default': false },
		addToCalendar: { type: 'bool', 'default': false },
		acceptedTitleRu: { type: 'string' },
		acceptedTitleEn: { type: 'string' },
		hideAcceptedTitle: { type: 'bool', 'default': false },
		acceptedSubtitleRu: { type: 'string' },
		acceptedSubtitleEn: { type: 'string' },
		hideAcceptedSubtitle: { type: 'bool', 'default': false },
	});
	this.fillFrom(data);

	this.eventTitle = ko.computed(() => this[Entity.localePropertyName('eventTitle')]());
	this.eventSubtitle = ko.computed(() => this[Entity.localePropertyName('eventSubtitle')]());
	this.date = ko.computed(() => this[Entity.localePropertyName('date')]());
	this.loginSubtitle = ko.computed(() => this[Entity.localePropertyName('loginSubtitle')]());
	this.registrationSubtitle = ko.computed(() => this[Entity.localePropertyName('registrationSubtitle')]());
	this.successTitle = ko.computed(() => this[Entity.localePropertyName('successTitle')]());
	this.successSubtitle = ko.computed(() => this[Entity.localePropertyName('successSubtitle')]());
	this.acceptedTitle = ko.computed(() => this[Entity.localePropertyName('acceptedTitle')]());
	this.acceptedSubtitle = ko.computed(() => this[Entity.localePropertyName('acceptedSubtitle')]());

	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.ModuleSettings);

Entity.Event.RegistrationField = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		name: { type: 'string' },
		defaultValue: { type: 'string' },
		type: { type: 'string' },
		label_ru: { type: 'string', keys: ['label'] },
		label_en: { type: 'string' },
		placeholder_ru: { type: 'string', keys: ['placeholder'] },
		placeholder_en: { type: 'string' },
		description_ru: { type: 'string', keys: ['description'] },
		description_en: { type: 'string' },
		regexp: { type: 'string' },
		min: { type: 'int' },
		max: { type: 'int' },
		required: { type: 'bool' }
	});
	this.fillFrom(data);

	this.label = ko.computed(() => this['label_' + Entity.localeName()]() || this.label_ru());
	this.placeholder = ko.computed(() => this['placeholder_' + Entity.localeName()]() || this.placeholder_ru());
	this.description = ko.computed(() => this['description_' + Entity.localeName()]() || this.description_ru());

	this.options = ko.observableArray(
		data && (data.options instanceof Array) ? data.options.map(optionData => new Entity.Event.RegistrationField.Option(optionData)) : []
	);
};
Entity.extend(Entity.Event.RegistrationField);
Entity.Event.RegistrationField.Option = function(data) {
	this.setMapper({
		id: { type: 'int' },
		value: { type: 'string' },
		label_ru: { type: 'string', keys: ['label'] },
		label_en: { type: 'string' }
	});
	this.fillFrom(data);

	this.label = ko.computed(() => this['label_' + Entity.localeName()]() || this.label_ru());
};
Entity.extend(Entity.Event.RegistrationField.Option);


Entity.Event.Module.Branding = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		welcomePage: { type: 'bool' },
		welcomePageTimeout: { type: 'int', 'default': 24 },
		share: { type: 'bool' },
		allowSMSNotifications: { type: 'bool', 'default': false },
		testSystem: { type: 'bool' },
		testSystemLink: { type: 'bool' },
		showComdiBanner: { type: 'bool' },
        calendarButton: { type: 'bool' },
		yandexMetrika: { type: 'string' },
		// googleAnalytics: { type: 'string' }
	});
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.Module.Branding);

Entity.Event.Module.Comment = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		enabled: { type: 'bool' },
        order: { type: 'int' },
		like: {type: 'bool'},
		moderate: { type: 'bool' },
		position: { type: ['bottom', 'right'], 'default': 'bottom' },
		allowAnonymousMessage: { type: 'bool', 'default': false },
        maxMessageLength: { type: 'int', 'default': 2046 },
	});
    this.allowAnswer = ko.computed(() => true);
    this.allowTargetMessage = ko.computed(() => false);
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.Module.Comment);

Entity.Event.Module.Question = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		enabled: { type: 'bool', 'default': false },
        order: { type: 'int' },
		moderate: { type: 'bool', 'default': false },
		position: { type: ['bottom', 'right'], 'default': 'bottom' },
		allowTargetMessage: { type: 'bool', 'default': false },
		allowTargetBeforeStart: { type: 'bool', 'default': false },
		allowAnonymousMessage: { type: 'bool', 'default': false },
        maxMessageLength: { type: 'int', 'default': 2046 },
	});
    this.like = ko.computed(() => true);
    this.allowAnswer = ko.computed(() => false);
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.Module.Question);

Entity.Event.Module.Twitter = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		enabled: { type: 'bool', 'default': false },
		timeout: { type: 'int', 'default': 60 },
		url: { type: 'string' },
		position: { type: ['bottom', 'right'], 'default': 'bottom' }
	});
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.Module.Twitter);

Entity.Event.Module.Episode = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		position: { type: ['bottom', 'right', 'hide'], 'default': 'right' },
		like: { type: 'bool', 'default': true },
		pixelInMinute: { type: 'int', 'default': 3 },
		showTable: { type: 'bool', 'default': false },
		episodeFavorite: { type: 'bool', 'default': true }
	});
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.Module.Episode);

Entity.Event.Module.Information = function(data) {
	const parser = BBCode['default'];

	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		position: { type: ['bottom', 'right'], 'default': 'bottom' },
		text_ru: { type: 'string', keys: ['text', 'ru_text'], 'default': '' },
		text_en: { type: 'string', keys: ['en_text'], 'default': '' }
	});
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());

	this.text = ko.computed(() => this['text_' + Entity.localeName()]() || this.text_ru());
	this.text_html = ko.computed(() => parser.parse(this.text() || ''));
};
Entity.extend(Entity.Event.Module.Information);

Entity.Event.Module.Theme = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		accentColor: { type: 'color' },
		textColor: { type: 'color' },
		backgroundColor: { type: 'color' },
		borderColor: { type: 'color' },
		playerTextColor: { type: 'color' },
		playerBackgroundColor: { type: 'color' },
		timeLineEpisodeColor: { type: 'color' },
		episodeTextColor: { type: 'color' },
		episodeBackgroundColor: { type: 'color' },
		poster: { type: 'string'},
	});
	this.fillFrom(data);

	this.fontFamily = data.fontFamily;

	this.event = () => Entity.Event.getInstance(this.eventId());
};
Entity.extend(Entity.Event.Module.Theme);


Entity.Event.Banner = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		link: { type: 'string' },
		url: { type: 'string' },
		timeout: { type: 'int' }
	});
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());
	this.event().banner.push(this);
};
Entity.extend(Entity.Event.Banner);

Entity.Event.MessageRoom = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		roomKey: { type: 'string' },
		roomType: { type: 'string' },
	});
	this.fillFrom(data);
};
Entity.extend(Entity.Event.MessageRoom);

Entity.Event.Stream = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		eventId: { type: 'int', keys: ['event_id'] },
		description_ru: { type: 'string', keys: ['description', 'ru_description'] },
		description_en: { type: 'string', keys: ['en_description'] },
		timeStart: { type: 'int' },
		timeStop: { type: 'int' },
		name: { type: 'string' },
		streamKey: { type: 'string' },
		publish: { type: 'bool' },
		'private': { type: 'bool' },
		autoplay: { type: 'bool' },
		order: { type: 'int' },
		dvr: { type: 'bool' },
		archiveStatus: { type: 'string' },
		status: { type: 'string' },
		preview: { type: 'string' },
		live: { type: 'bool' },
		manualStatusControl: { type: 'bool' },
		recordUpdatedAt: { type: 'int' },
        offset: { type: 'int' },
        duration: { type: 'int' }
	});
	this.fillFrom(data);
	this.event = () => Entity.Event.getInstance(this.eventId());

	this.description = ko.computed(() => this['description_' + Entity.localeName()]() || this.description_ru());

	this.getPreview = ko.computed(() => this.preview());

	this.episode = ko.observableArray();
    this.episode.subscribe(episodes => {
        let filtered = episodes.filter((episode) => !episode.participationType() || episode.participationType() === 'hybrid' || episode.participationType() === 'online');
        if (filtered.length !== episodes.length) {
            this.episode(filtered);
        }
    });
	this.stream = ko.observableArray();
	this.commentRoom = new Entity.Event.MessageRoom(data.commentRoom, this);
	this.questionRoom = new Entity.Event.MessageRoom(data.questionRoom, this);
	this.quality = ko.observableArray();
	this.language = ko.observableArray();
	this.liveServer = ko.observableArray();
	this.vodServer = ko.observableArray();
	this.server = ko.computed(() => in_array(this.archiveStatus(), ['done', 'file']) ? this.vodServer() : this.liveServer());
	this.broadcastSession = ko.observableArray();

    this.liveServerType = ko.computed(() => data?.liveProfile?.originType);

	if(data.episode instanceof Array) {
		data.episode.forEach(episode => new Entity.Event.Stream.Episode(episode));
	}

	if(data.stream instanceof Array) {
		data.stream.forEach(stream => new Entity.Event.Stream.Stream(stream));
	}

	if(data.quality instanceof Array) {
		data.quality.forEach(quality => new Entity.Event.Stream.Quality(quality));
	}

	if(data.language instanceof Array) {
		data.language.forEach(language => new Entity.Event.Stream.Language(language));
	}

	// if(data.viewServer instanceof Array) {
	// 	data.viewServer.forEach(server => new Entity.Event.Stream.Server(server));
	// }
	if(data.liveProfile && (data.liveProfile.viewServer instanceof Array)) {
		this.liveServer(data.liveProfile.viewServer.map(s => new Entity.Event.Stream.Server(s.server)));
	}

	if(data.vodProfile) {
		this.vodServer([new Entity.Event.Stream.Server(data.vodProfile)]);
	}

	if(data.broadcastSession instanceof Array) {
		data.broadcastSession.filter(session => !session.disabled).forEach(broadcastSession => new Entity.Event.Stream.BroadcastSession(broadcastSession));
	}

	this.episodeRecord = ko.computed(() => this.episode().filter(episode => episode.type() === 'record'));
	this.episodeLive = ko.computed(() => this.episode().filter(episode => episode.type() === 'live'));
	this.episodeIdle = ko.computed(() => this.episode().filter(episode => episode.type() === 'idle'));

	this.isRecorded = ko.computed(() => in_array(this.archiveStatus(), ['done', 'file']));
	this.isEpisodeRecorded = ko.computed(() => {
		let recorded = this.episode().length > 0;
		this.episode().forEach(episode => {
			if(episode.isDelay()) return;
			if(!episode.isRecorded()) {
				recorded = false;
			}
		});
		return recorded;
	});

    const recalculateIsLive = ko.observable(null);
	this.isLive = ko.computed(() => {
        recalculateIsLive();
        const sessions = this.broadcastSession();
        if (!sessions || !sessions.length) {
            return false;
        }

        const timeStop = sessions[sessions.length - 1].timeStop();
        if (!timeStop) {
            return true;
        }

        const timeToStop = timeStop + 40 - (Date.now() / 1000);
        if (timeToStop <= 0) {
            return false;
        }

        setTimeout(() => recalculateIsLive(Date.now()), timeToStop * 1000 + 100);

        return true;
	});

	this.event().stream.push(this);
};
Entity.extend(Entity.Event.Stream);
Entity.Event.Stream.prototype.remove = function() {
	this.event().stream.remove(this);
	this.removeInstance();
};
Entity.Event.Stream.prototype.getBroadcastSession = function(day) {
	let broadcastSession = this.broadcastSession();
	if(!isNaN(day)) {
		broadcastSession = broadcastSession.filter(function(broadcastSession) {
			return broadcastSession.day() === day;
		});
	}
	return broadcastSession[0] || null;
};
Entity.Event.Stream.prototype.getName = function(quality, lang, episode, day) {
	let stream = this.getStreamByDay(episode ? episode.day() : day);
	if(!stream) {
		stream = this;
	}
	let streamName = stream.name();
	if(episode && episode.isRecorded()) {
		streamName = this.name();
	}

	streamName += '_' + (quality && quality.number() ? quality.number() : 1);

	if(lang && lang.channel()) {
		streamName += '_' + lang.channel();
	}

	if(episode && episode.isRecorded()) {
		streamName += '_' + episode.id();
	} else if(in_array(stream.archiveStatus(), ['done', 'file'])) {
		if(stream.archiveStatus() === 'file') {
			streamName += '_0';
		}
	}
	return streamName;
};
Entity.Event.Stream.prototype.getUrl = function(quality, lang, episode, day) {
	let server = this.server();
	if(episode && episode.isRecorded()) {
		server = this.vodServer();
	}
    const isRecord = -1 !== ['done', 'file'].indexOf((episode || this).archiveStatus());
    const recordUpdatedAt = (episode || this).recordUpdatedAt();
    const [streamDayTimeStart, streamDayTimeStop, streamDayDuration] = getStreamDayRangeBySessions({
        timeStart: this.timeStart(),
        broadcastSession: this.broadcastSession().map((session) => session.getCleanData()),
    }, day, true);

	return server.map((server) => {
        let query = [];
        let streamPath = '';
        let streamName = this.name();
        let playlistName = 'index';

        if (server.type() === MEDIA_SERVER_TYPE_FLUSSONIC) {
            if (!isRecord && this.dvr() && streamDayTimeStart) {
                playlistName += '-' + streamDayTimeStart + '-' + (streamDayTimeStop ? streamDayDuration : 'now');
            } else if (episode && episode.isRecorded()) {
                streamName += '_' + episode.id()
            } else if ('file' === this.archiveStatus()) {
                streamName += '_0';
            }
        } else {
            streamName = this.getName(quality, lang, episode, day);
            playlistName = 'playlist';
            if (!isRecord && this.dvr()) {
                query.push('DVR');
            }
        }

        if (isRecord) {
            streamPath += `update/${recordUpdatedAt}/`;
            streamName += '.mp4';
        }

        return `${server.viewUrl()}${streamPath}${streamName}/${playlistName}.m3u8?${query.join('&')}`;
    });
};
Entity.Event.Stream.prototype.isArchive = function() {
	return in_array(this.archiveStatus(), ['done', 'file']);
};

Entity.Event.Stream.prototype.getPlayerTimeByAbsoluteTime = function(absoluteTime, day) {
	const broadcastSessions = this.getBroadcastSession(day);
	let playerTime = 0;
	for(let i = 0; i < broadcastSessions.length; i++) {
		const session = broadcastSessions[i];
		if(session.timeStart() < absoluteTime) {
			const timeStart = session.timeStart();
			const timeStop = session.timeStop() || (Math.round(Date.now() / 1000) + 3600*24);
			if(timeStop < absoluteTime) {
				playerTime += timeStop - timeStart;
			} else {
				playerTime += absoluteTime - timeStart;
				break;
			}
		}
	}
	return playerTime;
};
Entity.Event.Stream.prototype.getAbsoluteTimeByPlayerTime = function(playerTime, day) {
	day = isNaN(day) ? 0 : day;
	const broadcastSessions = this.getBroadcastSession(day);
//	broadcastSessions.sort(function(a, b) { return b.timeStart - a.timeStart; });
	for(let i=0; i<broadcastSessions.length; i++) {
		const session = broadcastSessions[i];
		if(session.timeStop()) {
			if(session.timeStop() - session.timeStart() > playerTime) {
				return session.timeStart() + playerTime;
			} else {
				playerTime -= session.timeStop() - session.timeStart();
			}
		} else {
			return session.timeStart() + playerTime;
		}
	}
};
Entity.Event.Stream.prototype.getEpisodeByPlayerTime = function(playerTime, day) {
	const absoluteTime = this.getAbsoluteTimeByPlayerTime(playerTime, day);
	let playerEpisode = null;
	for (let i = 0; i < this.episode().length; i++) {
		const episode = this.episode()[i];
		if(episode.timeStart() <= absoluteTime && episode.timeStop() > absoluteTime) {
			playerEpisode = episode;
		}
	}
	return playerEpisode;
};


Entity.Event.Stream.Episode = function(data) {
	const parser = BBCode['default'];

	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		streamId: { type: 'int', keys: ['stream_id'] },
		key: { type: 'string' },
        externalId: { type: 'string', keys: ['external_id'] },
		name_ru: { type: 'string', keys: ['name', 'ru_name', 'nameRu'] },
		name_en: { type: 'string', keys: ['en_name', 'nameEn'] },
		info_ru: { type: 'string', keys: ['info', 'ru_info', 'infoRu'], 'default': '' },
		info_en: { type: 'string', keys: ['en_info', 'infoEn'], 'default': '' },
		speaker: { type: 'list', keys: ['speakers'] },
		moderator: { type: 'list', keys: ['moderators'] },
		section_ru: { type: 'string', keys: ['section', 'ru_section', 'sectionRu'] },
		section_en: { type: 'string', keys: ['en_section', 'sectionEn'] },
        displayParticipationType: { type: 'string', 'default': null },
		member: { type: 'list' },
		like: { type: 'int' },
		liked: { type: 'bool' },
		timeStart: { type: 'int' },
		timeStop: { type: 'int' },
		offset: { type: 'int' },
		duration: { type: 'int' },
		isDelay: { type: 'bool' },
		color: { type: 'color' },
		code: { type: 'string' },
		order: { type: 'int' },
		archiveStatus: { type: 'string' },
		recordUpdatedAt: { type: 'int' },
		preview: { type: 'string' },
		participationType: { type: 'string' },
	});
	this.fillFrom(data);
	this.stream = () => Entity.Event.Stream.getInstance(this.streamId());

	this.isFavorite = ko.observable(false);
	this.toggleFavorite = () => this.isFavorite(!this.isFavorite());

	this.name = ko.computed(() => this['name_' + Entity.localeName()]() || this.name_ru());
	this.info = ko.computed(() => this['info_' + Entity.localeName()]() || this.info_ru());
	this.info_html = ko.computed(() => parser.parse(this.info() || ''));

	this.section = ko.computed(() => this['section_' + Entity.localeName()]());
	this.speakers = ko.computed(() => {
		let members = this.speaker() || [];
		if(members.length) {
			members = members.map(member => {
				member.fullnameRu = member.fullnameRu || member.fullname_ru || member.ru_fullname || member.fullname || '';
				member.fullnameEn = member.fullnameEn || member.fullname_en || member.en_fullname || member.fullname_ru;
				member.descriptionRu = member.descriptionRu || member.description_ru || member.ru_description || member.description || '';
				member.descriptionEn = member.descriptionEn || member.description_en || member.en_description || member.description_ru;
				return member;
			});
		}
		return members.map(member => {
			return {
				id: member.id,
				fullname: member[Entity.localePropertyName('fullname')],
				photo: member.photo,
				description: member[Entity.localePropertyName('description')]
			};
		});
	});
	this.moderators = ko.computed(() => {
		var members = this.moderator() || [];
		if(members.length) {
			members = members.map(member => {
				member.fullnameRu = member.fullnameRu || member.fullname_ru || member.ru_fullname || member.fullname || '';
				member.fullnameEn = member.fullnameEn || member.fullname_en || member.en_fullname || member.fullname_ru;
				member.descriptionRu = member.descriptionRu || member.description_ru || member.ru_description || member.description || '';
				member.descriptionEn = member.descriptionEn || member.description_en || member.en_description || member.description_ru;
				return member;
			});
		}
		return members.map(member => {
			return {
				id: member.id,
				fullname: member[Entity.localePropertyName('fullname')],
				photo: member.photo,
				description: member[Entity.localePropertyName('description')]
			};
		});
	});

	this.type = ko.computed(() => {
		const now = Entity.timeNow();

		if(this.timeStop() < now) return 'record';
		if(this.timeStart() > now) return 'idle';
		return 'live';
	});
	this.day = ko.computed(() => getStreamDay(this.stream().timeStart(), this.timeStart()));

	this.files = ko.observableArray();
	if(data.files instanceof Array) {
		data.files.forEach(file => new Entity.Event.Stream.Episode.File(file));
	}

	this.playerTimeStart = ko.computed(() => {
		this.stream().broadcastSession();
		if(in_array(this.stream().archiveStatus(), ['file'])) {
			return this.offset();
		} else if(in_array(this.stream().archiveStatus(), ['done'])) {
			return this.stream().getPlayerTimeByAbsoluteTime(this.timeStart());
		} else {
			return this.stream().getPlayerTimeByAbsoluteTime(this.timeStart(), this.day());
		}
	});
	this.playerTimeStop = ko.computed(() => {
		this.stream().broadcastSession();
		if(in_array(this.stream().archiveStatus(), ['file'])) {
			return this.offset() + this.duration();
		} else if(in_array(this.stream().archiveStatus(), ['done'])) {
			return this.stream().getPlayerTimeByAbsoluteTime(this.timeStop());
		} else {
			return this.stream().getPlayerTimeByAbsoluteTime(this.timeStop(), this.day());
		}
	});

	this.isRecorded = ko.computed(() => in_array(this.archiveStatus(), ['done', 'file']));

	this.getPreview = ko.computed(() => (this.preview() || this.stream().getPreview()));

	this.stream().episode.push(this);
};
Entity.extend(Entity.Event.Stream.Episode);
Entity.Event.Stream.Episode.prototype.remove = function() {
	this.stream().episode.remove(this);
	this.removeInstance();
};
Entity.Event.Stream.Episode.prototype.setLiked = function(liked) {
	episodeLikeToggle(this.id(), liked)
		.then(({like, liked}) => {
            this.like(like);
            this.liked(liked);
        })
	;
};

Entity.Event.Stream.Episode.File = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		episodeId: { type: 'int', keys: ['episode_id'] },
		url: { type: 'string' },
		title: { type: 'string' }
	});
	this.fillFrom(data);
	this.episode = () => Entity.Event.Stream.Episode.getInstance(data.episodeId);
	this.episode().files.push(this);
};
Entity.extend(Entity.Event.Stream.Episode.File);
Entity.Event.Stream.Episode.File.prototype.remove = function() {
	this.episode().files.remove(this);
	this.removeInstance();
};

Entity.Event.Stream.Quality = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		streamId: { type: 'int', keys: ['stream_id'] },
		number: { type: 'int' },
		bitrate: { type: 'int' },
		width: { type: 'int' },
		height: { type: 'int' },
		enabled: { type: 'bool', 'default': false },
		label: { type: 'string' },
        'default': { type: 'bool', 'default': false },
	});
	this.fillFrom(data);
	this.stream = () => Entity.Event.Stream.getInstance(this.streamId());

	this.description = ko.computed(() => {
		// if(this.height() >= 1080) return 'FullHD';
		// if(this.height() >= 720) return 'HD';
		// return 'SD';

		//return locale['player.quality.' + this.label().toLowerCase()] || '';
	});

	this.iconSup = ko.computed(() => {
		if(this.height() >= 1080) return 'FullHD';
		if(this.height() >= 720) return 'HD';
		return 'SD';
	});

	this.stream().quality.push(this);
};
Entity.extend(Entity.Event.Stream.Quality);
Entity.Event.Stream.Quality.prototype.remove = function() {
	this.stream().quality.remove(this);
	this.removeInstance();
};

Entity.Event.Stream.Language = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		streamId: { type: 'int', keys: ['stream_id'] },
		channel: { type: 'string' },
		label: { type: 'string' },
		description: { type: 'string' },
		enabled: { type: 'bool', 'default': false },
        'default': { type: 'bool', 'default': false },
	});
	this.fillFrom(data);
	this.stream = () => Entity.Event.Stream.getInstance(this.streamId());

	this.iconSup = ko.computed(() => {});

	this.stream().language.push(this);
};
Entity.extend(Entity.Event.Stream.Language);
Entity.Event.Stream.Language.prototype.remove = function() {
	this.stream().language.remove(this);
	this.removeInstance();
};

Entity.Event.Stream.Server = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		streamId: { type: 'int', keys: ['stream_id'] },
		name: { type: 'string' },
		viewUrl: { type: 'string' },
		ssl: { type: 'bool' },
		type: { type: 'string' },
		order: { type: 'int' }
	});
	this.fillFrom(data);
	this.stream = Entity.Event.Stream.getInstance(this.streamId());

//	this.stream().server.push(this);
};
Entity.extend(Entity.Event.Stream.Server);

Entity.Event.Stream.Stream = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		streamId: { type: 'int', keys: ['stream_id'] },
		name: { type: 'string' },
		day: { type: 'int' },
		archiveStatus: { type: 'string' }
	});
	this.fillFrom(data);
	this.stream = () => Entity.Event.Stream.getInstance(this.streamId());

	this.isRecorded = ko.computed(() => in_array(this.archiveStatus(), ['done', 'file']));

	this.stream().stream.push(this);
};
Entity.extend(Entity.Event.Stream.Stream);
Entity.Event.Stream.Stream.prototype.remove = function() {
	this.stream().stream.remove(this);
	this.removeInstance();
};

Entity.Event.Stream.BroadcastSession = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		streamId: { type: 'int', keys: ['stream_id'] },
        host: { type: 'string' },
		timeStart: { type: 'int' },
		timeStop: { type: 'int' }
	});
	this.fillFrom(data);
	this.stream = () => Entity.Event.Stream.getInstance(this.streamId());

	this.duration = ko.observable();

	const updateDuration = () => {
		this.duration((this.timeStop() || (Math.round(Date.now() / 1000) - 60)) - this.timeStart());
	};

	updateDuration();
	if(!this.timeStop()) {
		let timer;
		setInterval(updateDuration, 1000);
		this.timeStop.subscribe(() => {
			clearInterval(timer);
			updateDuration();
		});
	}

	this.stream().broadcastSession.push(this);
};
Entity.extend(Entity.Event.Stream.BroadcastSession);
Entity.Event.Stream.BroadcastSession.prototype.remove = function() {
	this.stream().broadcastSession.remove(this);
	this.removeInstance();
};


Entity.Comment = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		clientId: { type: 'int' },
		parentId: { type: 'int' },
		streamId: { type: 'int' },
		episodeId: { type: 'int' },
		playerTime: { type: 'int' },
		text: { type: 'string' },
		time: { type: 'int' },
		moderate: { type: 'bool' },
		likes: { type: 'int' },
		dislikes: { type: 'int' },
		fixed: { type: 'bool' },
		anonymous: { type: 'bool', 'default': false }
	});
	this.fillFrom(data);
	this.stream = () => Entity.Event.Stream.getInstance(this.streamId());

	this.text_html = ko.computed(() => replaceUrlsToLinks($('<div>').text(this.text()).html()));

	this.client = ko.computed(() => {
		if (this.anonymous()) {
			return null;
		}

		return new Entity.Client(data.client);
	});

	this.rated = ko.observable(parseBool(storage.get(`comment/message/${this.id()}/rated`)));

	this.answer = ko.observableArray();
};
Entity.extend(Entity.Comment);

Entity.Question = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: { type: 'int' },
		clientId: { type: 'int' },
		parentId: { type: 'int' },
		streamId: { type: 'int' },
		episodeId: { type: 'int' },
		playerTime: { type: 'int' },
		text: { type: 'string' },
		time: { type: 'int' },
		moderate: { type: 'bool' },
		likes: { type: 'int' },
		dislikes: { type: 'int' },
		fixed: { type: 'bool' },
		targetMember: { type: 'object' },
		anonymous: { type: 'bool', 'default': false }
	});
	this.fillFrom(data);
	this.stream = () => Entity.Event.Stream.getInstance(this.streamId());

	this.text_html = ko.computed(() => {
		let text = this.text();
		if (this.targetMember()) {
			const member = this.targetMember();
			const memberName = {
				ru: member.fullname || member.ru_fullname || member.fullname_ru || member.fullnameRu,
				en: member.en_fullname || member.fullname_en || member.fullnameEn
			};
			text = '@`' + memberName[Entity.localeName()] + '`, ' + text;
		}

		let html = $('<div>').text(text).html();
		html = replaceUrlsToLinks(html);
		html = html.replace(/@`([^`]+)`/, '<span class="message-receiver">@$1</span>');
		return html;
		}
	);

	this.client = ko.computed(() => {
		if (this.anonymous()) {
			return null;
		}

		return new Entity.Client(data.client);
	});

	this.rated = ko.observable(parseBool(storage.get(`question/message/${this.id()}/rated`)));

	this.answer = ko.observableArray();
};
Entity.extend(Entity.Question);

Entity.Poll = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: {type: 'int'},
		streamId: {type: 'int', keys: ['stream_id']},
		eventId: {type: 'int', keys: ['event_id']},
		'private': {type: 'bool'},
		percentage: {type: 'bool'},
		multiple: {type: 'bool'},
		textRu: {type: 'text'},
		textEn: {type: 'text'},
		status: {type: 'string'},
        prevStatus: {type: 'string'},
        statusChangedAt: {type: 'timestamp'},
		order: {type: 'int'},
		authorizationRequired: {type: 'bool'},
		type: {type: 'string'},
		answerNumber: {type: 'int'},
		object: {type: 'string'},
		options: {type: 'object'},
	});
	this.fillFrom(data);
	this.stream = () => Entity.Event.Stream.getInstance(this.streamId());

	const broadcastDelay = 0;

	const getStatus = (currentStatus, prevStatus, changedAt) => {
        if (changedAt.getTime() > Date.now() - broadcastDelay*1000) {
            setTimeout(
                () => this.statusDelayed(getStatus(currentStatus, prevStatus, changedAt)),
                Math.abs(changedAt.getTime() - Date.now()) + broadcastDelay*1000
            );

            return prevStatus;
        }

        return currentStatus;
    };

	this.statusDelayed = ko.observable(getStatus(
	    this.status(),
        this.prevStatus(),
        this.statusChangedAt()
    ));
    ko.computed(() => {
        this.statusDelayed(getStatus(
            this.status(),
            this.prevStatus(),
            this.statusChangedAt()
        ));
    });

    this.text = ko.computed(() => this[Entity.localePropertyName('text')]() || this.textRu());
	this.answer = ko.observableArray([]);

	this.isShow = ko.observable(true);

	this.isOpen = ko.computed(() => { return this.type() === 'open'; });
	this.isStandard = ko.computed(() => { return this.type() === 'standard'; });
	this.isRating = ko.computed(() => { return this.type() === 'rating'; });
	this.openAnswers = ko.observable(storage.get('openPollAnswers' + this.id()) || []);
	this.saveOpenAnswers = (data, event) => {
		const answers = $(event.target)
			.closest('form')
			.serializeArray()
			.filter(item => item.name === 'answers[]')
			.map(item => item.value.trim())
			.filter(item => item)
		;

		storage.set('openPollAnswers' + this.id(), answers);
		this.openAnswers(answers);
	};

	this.isVoted = ko.computed(() => {
		return this.voted.indexOf(this.id()) !== -1;
	});
	this.isCanVote = ko.computed(() => { return this.statusDelayed() === 'active' && !this.isVoted(); });

	this.isActive = ko.computed(() => { return this.statusDelayed() === 'active'; });
	this.isResult = ko.computed(() => { return this.statusDelayed() === 'result'; });

	this.answerSum = ko.computed(() => {
		return this.answer().reduce((sum, answer) => sum + answer.count(), 0);
	});

	if (data.answer instanceof Array) {
		this.answer(
			data.answer
				.sort((a, b) => a.order - b.order)
				.map((answer) => new Entity.Poll.Answer(answer))
		);
	}

	ko.computed(() => {
		this.statusDelayed();
		this.isShow(true);
	});

	this.validateAnswer = () => {
		if (this.isRating()) {
			const unrated = this.answer().find(answer => 0 === answer.rating());
			if (unrated) {
				alert('Вы должны оценить все критерии');

				return false;
			}

			return true;
		}

		return true;
	};

	this.vote = () => {
		this.voted.push(this.id());
	};

	this.answerData = () => {
		if (this.isRating()) {
			const answers = {};
			this.answer().forEach(item => {
				answers[item.id()] = item.rating();
			});

			return {answers};
		}
	};
};
Entity.extend(Entity.Poll);
Entity.Poll.prototype.voted = ko.observableArray(storage.get('pollsVoted') || []);
Entity.Poll.prototype.voted.subscribe(function(voted) { storage.set('pollsVoted', voted, storage.DAY * 7); });

Entity.Poll.Answer = function(data) {
	this.setInstance(data.id);
	this.setMapper({
		id: {type: 'int'},
		pollId: {type: 'int', keys: ['poll_id']},
		textRu: {type: 'text'},
		textEn: {type: 'text'},
		count: {type: 'int'},
		color: {type: 'color'},
		ratingMax: {type: 'int'},
		ratingSum: {type: 'int'},
	});
	this.fillFrom(data);
	this.poll = () => Entity.Poll.getInstance(data.pollId);

	this.text = ko.computed(() => this[Entity.localePropertyName('text')]() || this.textRu());
	this.isSelected = ko.computed(() => this.selected.indexOf(this.id()) >= 0);

	this.rating = ko.computed(() => this.rated()[this.id()] || 0);

	this.percentage = ko.computed(() => {
		const sum = this.poll().answerSum();
		const percentage = sum ? (this.count() / this.poll().answerSum() * 100) : 0;
		return Math.round(percentage);
	});

	this.select = () => this.selected.push(this.id());
	this.unselect = () => this.selected.remove(this.id());
	this.toggleSelect = () => -1 === this.selected.indexOf(this.id()) ? this.select() : this.unselect();

	this.rate = (rating) => {
		if (this.poll().isVoted()) {
			return;
		}

		const rated = {
			...this.rated(),
			[this.id()]: rating,
		};

		this.rated(rated);
	}
};
Entity.extend(Entity.Poll.Answer);
Entity.Poll.Answer.prototype.selected = ko.observableArray(JSON.parse(storage.get('pollAnswers') || '[]'));
Entity.Poll.Answer.prototype.selected.subscribe(function(selected) { storage.set('pollAnswers', JSON.stringify(selected), storage.DAY * 7); });
Entity.Poll.Answer.prototype.rated = ko.observable(JSON.parse(storage.get('pollAnswersRating') || '{}'));
Entity.Poll.Answer.prototype.rated.subscribe(function(rated) { storage.set('pollAnswersRating', JSON.stringify(rated), storage.DAY * 7); });

// ---------------------------------------------------------------------------------------------------------------------


Entity.Event.Stream.Episode.prototype.getNextEpisode = function() {
	const episodes = this.stream().episode();
	const episodeIndex = episodes.indexOf(this);
	if(episodeIndex >= 0 && typeof episodes[episodeIndex + 1] !== 'undefined') {
		return episodes[episodeIndex + 1];
	}
};

Entity.Event.Stream.Stream.prototype.getBroadcastSession = function() {
	const stream = this.stream();
	const streamDate = moment.unix(stream.timeStart() + this.day() * 3600 * 24);

    let broadcastSessions = stream.broadcastSession();

    if (broadcastSessions.length > 0) {
        const lastBroadcastSession = broadcastSessions[broadcastSessions.length - 1];
        broadcastSessions = broadcastSessions.filter(session => session.host() === lastBroadcastSession.host());
    }

    return broadcastSessions.filter((broadcastSession) =>
        streamDate.format('YYYY-MM-DD') === moment.unix(broadcastSession.timeStart()).format('YYYY-MM-DD')
    );
};

Entity.Event.Stream.prototype.getNextStream = function() {
	const streams = this.event().stream();
	const streamIndex = streams.indexOf(this);
	if(streamIndex >= 0 && typeof streams[streamIndex + 1] !== 'undefined') {
		return streams[streamIndex + 1];
	}
};
Entity.Event.Stream.prototype.getBroadcastSession = function(day) {
    let broadcastSessions = this.broadcastSession();

    if (broadcastSessions.length > 0) {
        const lastBroadcastSession = broadcastSessions[broadcastSessions.length - 1];
        broadcastSessions = broadcastSessions.filter(session => session.host() === lastBroadcastSession.host());
    }

	if(isNaN(day)) {
		return broadcastSessions;
	}
	const stream = this.getStreamStream(day);
	if(stream instanceof Entity.Event.Stream.Stream) {
		if(in_array(this.archiveStatus(), ['done', 'file']) && !in_array(stream.archiveStatus(), ['done', 'file'])) {
			return broadcastSessions;
		}
		const streamDate = moment.unix(this.timeStart() + day * 3600 * 24);
		return broadcastSessions
			.filter(session => streamDate.format('YYYY-MM-DD') === moment.unix(session.timeStart()).format('YYYY-MM-DD'));
	}
	return broadcastSessions;
};
Entity.Event.Stream.prototype.getStreamStream = function(day) {
	if(isNaN(day)) {
		if(in_array(this.status(), ['live', 'pause']) && this.stream().length) {
			return this.stream()[this.stream().length - 1];
		} else if(this.stream()[0]) {
			return this.stream()[0];
		}
	} else {
		const stream = this.stream()
			.find(stream => stream.day() === day);
		if(stream) return stream;
	}
	return this;
};
Entity.Event.Stream.prototype.getStreamByDay = function(day) {
	let stream = this.getStreamStream(day);
	if(stream instanceof Entity.Event.Stream.Stream) {
		if(in_array(this.archiveStatus(), ['done', 'file']) && !in_array(stream.archiveStatus(), ['done', 'file'])) {
			stream = this;
		}
	}
	return stream;
};
Entity.Event.Stream.prototype.isLive = function() {
	for(let i = 0; i < this.broadcastSession().length; i++) {
		const session = this.broadcastSession()[i];
		if(!session.timeStop()) {
			return true;
		}
	}
	return false;
};
Entity.Event.Stream.prototype.isArchive = function() {
	return in_array(this.archiveStatus(), ['done', 'file']);
};
Entity.Event.Stream.prototype.isEpisodeRecorded = function() {
	let recorded = true;
	this.episode().forEach(function(episode) {
		if(!episode.isDelay()) {
			if(!in_array(episode.archiveStatus(), ['done', 'file'])) {
				recorded = false;
			}
		}
	});
	return recorded;
};


Entity.Notification = function(data) {
	this.setMapper({
		id: { type: 'int' },
		link: { type: 'string' },
		text: { type: 'string', 'default': '' },
		banner: { type: 'string' },
		bannerWidth: { type: 'int' },
		bannerHeight: { type: 'int' },
		time: { type: 'int' }
	});
	this.fillFrom(data);

	this.html = ko.computed(() => (this.text() || '')
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#039;")
			.replace(/\[(\/)?([biu])\]/gi, '<$1$2>')
			.replace(/((https|http|ftp|ssl|mailto):\/\/[^\s<]+)/gi, '<a href="$1" target="_blank">$1</a>')
			.replace(/\n/g, "<br>")
		);

	this.link = ko.computed(() => this.link() ? `/api/player/event/notification/${this.id()}/click` : '');
};
Entity.extend(Entity.Notification);

window.Entity = Entity;
export default Entity;
